import { render } from "./ordersView.vue?vue&type=template&id=993537d6"
import script from "./ordersView.vue?vue&type=script&lang=js"
export * from "./ordersView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__